var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6923 10.8205V14.0128C15.6923 14.4361 15.5241 14.8421 15.2248 15.1415C14.9254 15.4408 14.5195 15.609 14.0961 15.609H2.92306C2.49973 15.609 2.09374 15.4408 1.79441 15.1415C1.49507 14.8421 1.3269 14.4361 1.3269 14.0128V10.8205",
    stroke: "#949494",
    strokeWidth: 1.59615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50952 10.8205V1.24359",
    stroke: "#949494",
    strokeWidth: 1.59615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51929 6.83012L8.50967 10.8205L12.5001 6.83012",
    stroke: "#949494",
    strokeWidth: 1.59615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadButton);
export default __webpack_public_path__ + "static/media/DownloadButton.35d172fb2a6a65625d6229bd246c9bdc.svg";
export { ForwardRef as ReactComponent };